export const form140Sections = [
    { value: '1004', label: '1004 - Any payment of accumulated balance due to an employee' },
    { value: '1005', label: '1005 - Commission or brokerage - insurance' },
    { value: '1006', label: '1006 - Commission or Brokerage - others' },
    { value: '1008', label: '1008 - Rent on machinery etc.- specified person' },
    { value: '1009', label: '1009 - Rent other than machinery etc.- specified person' },
    { value: '1011', label: '1011 - Payment on any consideration... under section 67(14)' },
    { value: '1012', label: '1012 - Payment of Compensation on Acquisition of Certain Immovable Property' },
    { value: '1013', label: '1013 - Income payable to a resident assessee in respect of Units...' },
    { value: '1014', label: '1014 - Certain income in the form of interest from units of a business trust...' },
    { value: '1015', label: '1015 - Certain income in the form of dividend from units of a business trust...' },
    { value: '1017', label: '1017 - Any income... in respect of units of an investment fund...' },
    { value: '1018', label: '1018 - Any income, in respect of an investment in a securitisation trust...' },
    { value: '1019', label: '1019 - Any income by way of Interest on securities' },
    { value: '1020', label: '1020 - Interest other than interest on securities (Senior citizen)' },
    { value: '1021', label: '1021 - Interest other than interest on securities (Other than senior citizen)' },
    { value: '1022', label: '1022 - Any income being interest other than interest on securities' },
    { value: '1023', label: '1023 - Any sum for carrying out any work... (Individual/HUF)' },
    { value: '1024', label: '1024 - Any sum for carrying out any work... (Other than Individual/HUF)' },
    { value: '1026', label: '1026 - Fees for technical services / royalty / call centre' },
    { value: '1027', label: '1027 - Fees for professional services' },
    { value: '1028', label: '1028 - Remuneration/fees/commission to a director' },
    { value: '1029', label: '1029 - Any dividends (including on preference shares) declared' },
    { value: '1030', label: '1030 - Any sum under a life insurance policy' },
    { value: '1031', label: '1031 - Any sum for purchase of any goods' },
    { value: '1033', label: '1033 - Any benefit or perquisite... arising from business or profession' },
    { value: '1034', label: '1034 - Benefits or perquisites of business/profession provided in kind' },
    { value: '1035', label: '1035 - Sale of goods/services by an e-commerce participant' },
    { value: '1037', label: '1037 - Consideration for transfer of virtual digital asset (Other than Ind/HUF)' },
    { value: '1038', label: '1038 - Consideration for transfer of virtual digital asset' },
    { value: '1058', label: '1058 - Winnings from lottery / crossword / games / gambling' },
    { value: '1059', label: '1059 - Winnings from lottery / crossword / games / gambling (in kind)' },
    { value: '1060', label: '1060 - Winnings from online game' },
    { value: '1061', label: '1061 - Winnings from online game (in kind)' },
    { value: '1062', label: '1062 - Winnings from any horse race' },
    { value: '1063', label: '1063 - Commission/remuneration/prize on lottery tickets' },
    { value: '1064', label: '1064 - Cash payment by bank/post office to a co-operative society' },
    { value: '1065', label: '1065 - Cash payment by bank/post office to person other than co-op society' },
    { value: '1066', label: '1066 - Any amount referred to in section 80CCA(2)(a)' },
    { value: '1067', label: '1067 - Salary/remuneration/interest paid to a partner' }
];

export const minorHeadCodes140 = [
    { value: '200', label: '200 - TDS payable by taxpayer' },
    { value: '400', label: '400 - TDS regular assessment (Raised by I. T, Dept.)' },
    { value: '100', label: '100 - Advance Tax' }
];

export const deductorTypes140 = [
    { value: 'A', label: 'Central Government' },
    { value: 'S', label: 'State Government' },
    { value: 'D', label: 'Statutory body (Central Govt.)' },
    { value: 'E', label: 'Statutory body (State Govt.)' },
    { value: 'G', label: 'Autonomous body (Central Govt.)' },
    { value: 'H', label: 'Autonomous body (State Govt.)' },
    { value: 'L', label: 'Local Authority (Central Govt.)' },
    { value: 'N', label: 'Local Authority (State Govt.)' },
    { value: 'K', label: 'Company' },
    { value: 'M', label: 'Branch / Division of Company' },
    { value: 'P', label: 'Association of Person (AOP)' },
    { value: 'T', label: 'Association of Person (Trust)' },
    { value: 'J', label: 'Artificial Juridical Person' },
    { value: 'B', label: 'Body of Individuals' },
    { value: 'Q', label: 'Individual/HUF' },
    { value: 'F', label: 'Firm' }
];
